import { useEffect, useState } from 'react'
import { isAndroid } from '@/lib/platform'
import {
  androidBottomNavPillPx,
  readAndroidNavigationBarInsetPx,
} from '@/lib/nativeStatusBar'

function readInsetFromDom(): number {
  if (typeof document === 'undefined') return 0

  const px = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--gmt-android-nav-bottom-inset'),
  )
  return px > 0 ? px : 0
}

/** Android pill bottom offset (native inset minus tuck). */
export function useAndroidBottomNavOffset(): number {
  const [offsetPx, setOffsetPx] = useState(() =>
    isAndroid() ? androidBottomNavPillPx(readInsetFromDom() || 48) : 0,
  )

  useEffect(() => {
    if (!isAndroid()) return

    let cancelled = false

    const sync = async () => {
      const nativePx = await readAndroidNavigationBarInsetPx()
      const pillPx = androidBottomNavPillPx(nativePx)
      if (cancelled) return
      setOffsetPx(pillPx)
      document.documentElement.style.setProperty('--gmt-android-nav-bottom-inset', `${nativePx}px`)
      document.documentElement.style.setProperty('--bottom-nav-pill-bottom', `${pillPx}px`)
      document.documentElement.style.setProperty('--bottom-nav-lift', `${pillPx}px`)
    }

    void sync()

    const onLayoutChange = () => {
      void sync()
    }

    window.addEventListener('orientationchange', onLayoutChange)
    window.visualViewport?.addEventListener('resize', onLayoutChange)

    const t1 = window.setTimeout(() => {
      void sync()
    }, 250)
    const t2 = window.setTimeout(() => {
      void sync()
    }, 900)

    return () => {
      cancelled = true
      window.removeEventListener('orientationchange', onLayoutChange)
      window.visualViewport?.removeEventListener('resize', onLayoutChange)
      window.clearTimeout(t1)
      window.clearTimeout(t2)
    }
  }, [])

  return offsetPx
}
